import { render, staticRenderFns } from "./ProcesoMainTransform.vue?vue&type=template&id=3e6b0a24&"
import script from "./ProcesoMainTransform.vue?vue&type=script&lang=js&"
export * from "./ProcesoMainTransform.vue?vue&type=script&lang=js&"
import style0 from "./ProcesoMainTransform.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports